<template>
  <nav class="s-shop-steps">
    <div class="s-steps" v-if="!showOffer">
      <a href="#streaming" class="s-step" data-step="01">
        <span class="s-step__number">01&nbsp;</span>
        <span class="s-step__name">{{ stepTitles.slang_steps_1 }}</span>
      </a>
      <a href="#analyse" class="s-step" data-step="02">
        <span class="s-step__number">02&nbsp;</span>
        <span class="s-step__name">{{ stepTitles.slang_steps_2 }}</span>
      </a>
      <a href="#kamera" class="s-step" data-step="03">
        <span class="s-step__number">03&nbsp;</span>
        <span class="s-step__name">{{ stepTitles.slang_steps_3 }}</span>
      </a>
      <a href="#address" class="s-step" data-step="04">
        <span class="s-step__number">04&nbsp;</span>
        <span class="s-step__name">{{ stepTitles.slang_steps_4 }}</span>
      </a>
    </div>

    <div class="s-steps" v-if="showOffer">
      <a href="#offer" class="s-step" data-step="01">
        <span class="s-step__number">01&nbsp;</span>
        <span class="s-step__name">{{ stepTitles.slang_steps_offer }}</span>
      </a>
      <a href="#address" class="s-step" data-step="02">
        <span class="s-step__number">02&nbsp;</span>
        <span class="s-step__name">{{ stepTitles.slang_steps_4 }}</span>
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  computed: {
    stepTitles(){
      return this.$store.state.wpdata[wpGlobalData.language].translations.slang_steps[0];
    },
    showOffer(){
      return this.$store.state.showOffer && this.$store.state.wpdata[wpGlobalData.language].offer.activate_offer;
    }
  },
  data() {
    return {
      activeStep: 1
    };
  },
  methods: {
    setActiveStep(active) {
      this.activeStep = active;
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StepNavigation.vue